export var toplevel = typeof window !== "undefined" ? window : global;
export var supportShadowDom = toplevel.HTMLElement !== undefined &&
    toplevel.HTMLElement.prototype !== undefined &&
    toplevel.HTMLElement.prototype.attachShadow !== undefined;
// tslint:disable:object-literal-sort-keys
export var WidgetLogLevelValues = {
    debug: 10,
    info: 20,
    warn: 30,
    error: 40,
};
// tslint:enable:object-literal-sort-keys
//# sourceMappingURL=toplevel.js.map